import { Link } from "@tanstack/react-router";
import { TalkToJonButton } from "@/components/talk-to-jon";

type Props = {
  /** Optional line tailored to the page this sits on. */
  line?: string;
  className?: string;
};

/**
 * The Library carries almost all of our search impressions, so every gem,
 * category and round-up page gets one quiet invitation to talk to us.
 * Deliberately small: the page is a reference, not a pitch.
 */
export function LibraryHelpCta({ line, className }: Props) {
  return (
    <aside
      aria-labelledby="library-help-h"
      className={`mt-16 rounded-2xl border border-border bg-card p-6 md:p-8 ${className ?? ""}`}
    >
      <h2 id="library-help-h" className="font-display text-xl md:text-2xl tracking-[-0.02em]">
        Stuck building this?
      </h2>
      <p className="mt-3 max-w-[60ch] text-[15px] md:text-base leading-relaxed text-muted-foreground">
        {line ??
          "We're full-stack designers and a vibe coding agency — we wire tools like this into real products every week, in Lovable, Cursor and Claude Code. Bring the half-built version and we'll get it shipped."}
      </p>
      <div className="mt-6 flex flex-wrap items-center gap-5">
        <TalkToJonButton variant="dark" />
        <Link
          to="/services"
          className="font-display text-electric underline underline-offset-4"
        >
          What we do →
        </Link>
      </div>
    </aside>
  );
}
